import type { FunctionComponent } from 'react';
import * as s from './ConsultantSection.css';
import type * as T from './ConsultantSection.types';
import Title from '@media-ui/core/src/components/Title';
import Link from '@media-ui/core/src/components/Link';
import Text from '@media-ui/core/src/components/Text';
import ConsultantListing from 'Src/components/ConsultantListing';
import Section from '@media-ui/core/src/components/Section';
import { counterTrigger } from 'Src/tools/counters';
import classNames from 'classnames';
const ConsultantSection: FunctionComponent<T.IConsultantSectionProps> = (props) => {
    const { consultants: { list, count, href }, clickCounterName, titleCounterName, moreText, moreHref, isCentered, withWrapper = true, separator, } = props;
    const handleClick = () => {
        if (titleCounterName) {
            counterTrigger(titleCounterName);
        }
    };
    return (<Section className={classNames(s.root, {
            [s.centered]: isCentered,
        })} withWrapper={withWrapper} separator={separator} title={<Title level="5" mediaLevel tag="h2" className={s.title}>
          <Link href={href} holder className={s.titleLink} onClick={handleClick}>
            Наши специалисты
          </Link>
          <Text type="articleParagraph" color="secondary">
            {count}
          </Text>
        </Title>} moreText={moreText} moreHref={moreHref}>
      <ConsultantListing consultants={list} clickCounterName={clickCounterName}/>
    </Section>);
};
export default ConsultantSection;
